import {Api} from "./api";

export const api = new Api('https://jid-api.billestauner.dk');
export const newCountryTime = 30; // minutes old
